import React from 'react';
import Heading from '../../../../generic-components/Heading';
import { useStore } from '../../../../store';

export const TransactionInitiatorPan = () => {
  const transaction = useStore((state) => state.selectedTransaction);

  function shouldShowPan() {
    const firstName = transaction?.initiatorFirstName;
    const lastName = transaction?.initiatorLastName;
    const panId = transaction?.initiatorPan;
    return [firstName, lastName, panId].some((i) => i);
  }

  function getInitials() {
    return `${transaction?.initiatorFirstName?.charAt(0) || ''}${transaction?.initiatorLastName?.charAt(0) || ''}`;
  }

  return shouldShowPan() ? (
    <div className='mt-auto flex items-center'>
      {getInitials() && (
        <div className='rounded-[50%] bg-action05 w-[24px] h-[24px] flex items-center justify-center mr-[6px]'>
          <Heading title={getInitials()} className='font-metricRMedium text-[9px] text-bw00 leading-none' />
        </div>
      )}
      {getInitials() && (
        <Heading
          id='initiatedByName'
          title={`Initiated by ${transaction?.initiatorFirstName} ${transaction?.initiatorLastName}`}
          className='font-metricR text-[14px] text-bw07'
        />
      )}
      {getInitials() && transaction?.initiatorPan && (
        <span id='panSeparator' className='mx-[4px] font-metricR text-[14px] text-bw07'>
          |
        </span>
      )}
      {transaction?.initiatorPan && (
        <Heading
          id='cardPanId'
          title={`Card **${transaction.initiatorPan}`}
          className='font-metricR text-[14px] text-bw07'
        />
      )}
    </div>
  ) : null;
};
